import GlobalLayout from 'containers/Layout/GlobalLayout'
import { RouteTemplateProperties } from './types/RouteTemplateProperties'
import { RouteTypeEnum } from './types/routeTypes'
import platform from './platform'
import admin from './admin'

const routesTemplate: RouteTemplateProperties[] = [
  {
    routes: platform,
    template: GlobalLayout,
    type: RouteTypeEnum.private,
  },
  {
    routes: admin,
    template: GlobalLayout,
    type: RouteTypeEnum.private,
  },
]
export default routesTemplate
